/** 静态资源：`public/logo.png` 在构建/开发中映射为站点根路径 */
export const LOGO_PUBLIC_SRC = '/logo.png' as const
